<template>
    <div class="roteirizacao-weekday-filter">
        <div v-if="showLabel" class="text-caption text--secondary mb-1">
            {{ resolvedLabel }}
        </div>
        <v-btn-toggle
            :value="normalizedValue"
            multiple
            dense
            class="roteirizacao-weekday-filter__toggle"
            @change="onChange"
        >
            <v-btn
                v-for="day in weekdayOptions"
                :key="day.value"
                :value="day.value"
                small
                class="roteirizacao-weekday-filter__btn"
            >
                {{ day.text }}
            </v-btn>
        </v-btn-toggle>
    </div>
</template>

<script>
import { WEEKDAY_KEYS } from '@/utils/roteirizacaoCicloPagamento';

export default {
    name: 'RoteirizacaoWeekdayFilter',
    props: {
        value: {
            type: Array,
            default: () => WEEKDAY_KEYS.slice(),
        },
        label: {
            type: String,
            default: '',
        },
        hideLabel: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        showLabel() {
            return !this.hideLabel;
        },
        resolvedLabel() {
            return this.label || this.$t('routePlanning.sidebar.costWeekdays');
        },
        weekdayOptions() {
            return WEEKDAY_KEYS.map((key) => ({
                value: key,
                text: this.$t(`datetime.weekdays.${key}`),
            }));
        },
        normalizedValue() {
            const selected = Array.isArray(this.value) ? this.value : [];
            const unique = [...new Set(selected.filter((k) => WEEKDAY_KEYS.includes(k)))];
            return unique.length ? unique : [WEEKDAY_KEYS[0]];
        },
    },
    methods: {
        onChange(next) {
            let selected = Array.isArray(next) ? next : [];
            selected = [...new Set(selected.filter((k) => WEEKDAY_KEYS.includes(k)))];
            if (!selected.length) {
                selected = [WEEKDAY_KEYS[0]];
            }
            // Mantém ordem operacional (segunda → domingo).
            selected = WEEKDAY_KEYS.filter((k) => selected.includes(k));
            this.$emit('input', selected);
            this.$emit('change', selected);
        },
    },
};
</script>

<style scoped>
.roteirizacao-weekday-filter {
    width: 100%;
}
.roteirizacao-weekday-filter__toggle {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
}
.roteirizacao-weekday-filter__btn {
    flex: 1 1 auto;
    min-width: 36px;
    text-transform: none;
    letter-spacing: normal;
}
</style>
